module.exports = __webpack_public_path__ + "static/gatsbynbooch-0253aa8c96e0183aa356690a7306aab3.jpg";